import React from 'react';

const STAR = 'M0,-1 L0.294,-0.405 L0.951,-0.309 L0.476,0.155 L0.588,0.809 L0,0.5 L-0.588,0.809 L-0.476,0.155 L-0.951,-0.309 L-0.294,-0.405 Z';

// Variant "flag": classic euroband (12-star circle above the letter)
const FlagBand = ({ letter, className }) => (
  <div className={`bg-[#003399] text-white px-2.5 flex flex-col items-center justify-center gap-0.5 ${className}`} data-testid="plate-euroband" aria-label="Plaque française">
    <svg viewBox="-12 -12 24 24" className="w-6 h-6" aria-hidden="true">
      {Array.from({ length: 12 }).map((_, i) => {
        const a = (i / 12) * Math.PI * 2;
        return <path key={i} d={STAR} fill="#FFCC00" transform={`translate(${Math.sin(a) * 9.5} ${-Math.cos(a) * 9.5}) scale(2)`} />;
      })}
    </svg>
    <span className="text-sm font-bold leading-none">{letter}</span>
  </div>
);

// Variant "badge": blue ring with 3 stars on top, dashed arcs, letter in the white centre (test requested by the user)
const BadgeBand = ({ letter, className }) => (
  <div className={`bg-[#003399] px-1.5 flex items-center justify-center ${className}`} data-testid="plate-euroband" aria-label="Plaque française">
    <svg viewBox="-50 -50 100 100" className="w-11 h-11" aria-hidden="true">
      <defs>
        <linearGradient id="plate-badge-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#0A4DB5" />
          <stop offset="1" stopColor="#0B2C7A" />
        </linearGradient>
      </defs>
      <circle r="48" fill="url(#plate-badge-grad)" />
      <circle r="21" fill="#fff" />
      {[-105, -147, 180, 147, 105].map((deg) => {
        const r = 34, half = 11, a1 = ((deg - half) * Math.PI) / 180, a2 = ((deg + half) * Math.PI) / 180;
        return <path key={deg} d={`M${r * Math.sin(a1)} ${-r * Math.cos(a1)} A${r} ${r} 0 0 1 ${r * Math.sin(a2)} ${-r * Math.cos(a2)}`} fill="none" stroke="#fff" strokeWidth="5.5" strokeLinecap="round" />;
      })}
      {[-16, 0, 16].map((x, i) => (
        <path key={x} d={STAR} fill="#FFCC00" transform={`translate(${x} ${i === 1 ? -36 : -32}) scale(${i === 1 ? 6.5 : 5.5})`} />
      ))}
      <text y="9" textAnchor="middle" fontSize="26" fontWeight="800" fill="#003399" fontFamily="Arial, Helvetica, sans-serif">{letter}</text>
    </svg>
  </div>
);

export const EuroBand = ({ letter = 'F', className = '', variant = 'badge' }) => (variant === 'flag' ? <FlagBand letter={letter} className={className} /> : <BadgeBand letter={letter} className={className} />);

export default EuroBand;
